import { LOADED_THEME, SUPPORTED_THEMES } from '~persistence/theme';
import PLATFORMS from './platforms';
export function getPlatform() {
    const themeId = Object.entries(SUPPORTED_THEMES).find(x => LOADED_THEME === x[1])?.[0];
    if (!themeId) {
        return PLATFORMS.mipasa;
    }
    return PLATFORMS[themeId.split('-')[0]] || PLATFORMS.mipasa;
}
